module.exports = __webpack_public_path__ + "img/error-404-xs.7275f29a.jpg";